
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import moment from 'moment';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Impferinnerungsbrief from '@/types/Impferinnerungsbrief';
    import { Geschlecht } from '@/types/Geschlecht';
    import { ValidationRules } from '@/store/types';
    import { VForm } from '@/types/Components';
    import Impfstelle from '@/types/Impfstelle';
    import { PrintBriefPayload } from '@/store/impferinnerungen';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import Beleg from '@/types/Beleg';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules', 'formatDate', 'parseDate']),
            ...mapState('patient', ['patientData']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapGetters('authentication', ['impfstelleDetail', 'getSystemEinstellung']),
            ...mapState('zahlungserinnerungen', ['loaders', 'brief']),
            ...mapGetters('personen', ['getPersonen']),
            ...mapState('personen', { personenLoaders: 'loaders' }),
            ...mapState('kassafuehrung', ['offeneZahlscheinBelege', 'beleg']),
            ...mapState('authentication', ['impfstelle']),
        },
        methods: {
            ...mapActions('zahlungserinnerungen', ['printBrief']),
            ...mapActions('personen', ['loadPersonen']),
            ...mapMutations('patient', ['setDialogRezept']),
            ...mapActions('authentication', ['loadImpfstelle']),
        },
    })
    export default class RechnungserinnerungsbriefDetail extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
            text: Vue;
        };

        public rules!: ValidationRules;
        public brief!: Impferinnerungsbrief;
        public impfstelle_id!: number;
        public impfstelleDetail!: Impfstelle;
        public impfstelle!: Impfstelle;
        public printBrief!: (payload: PrintBriefPayload) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public loadImpfstelle!: () => void;
        public formatDate!: (input: string | null) => string | any;

        public text = '';
        public beleg!: Beleg;
        public textErrorMessage = '';

        public get briefTitel(): string {
            if (!this.beleg) return '';

            return this.beleg.patient_geschlecht === Geschlecht.Maennlich
                ? 'Herr '
                : this.beleg.patient_geschlecht === Geschlecht.Weiblich
                    ? 'Frau '
                    : '';
        }

        public get briefOrtDatum(): string {
            return `${this.getSystemEinstellung('brief_ortsname').toString()}, ${moment().format('DD. MMMM YYYY')}`;
        }

        public platzhalterBefuellen(): string {
            if (this.impfstelle.zahlungserinnerungstext) {
                var titelText;
                if (this.briefTitel === 'Frau ') {
                    titelText = 'Sehr geehrte';
                } else {
                    titelText = 'Sehr geehrter';
                }
                return this.text = this.impfstelle.zahlungserinnerungstext
                    .replace('{HN-DATUM}', this.formatDate(this.beleg.datum))
                    .replace('{HN-NUMMER}', this.beleg.jahr + '|' + this.beleg.belegnr)
                    .replace('{HN-RECHNUNGSBETRAG}', '€ ' + this.$b(this.beleg.gesamtbetrag))
                    .replace('{HN-NAME}', titelText + ' ' + this.briefTitel +
                        (this.beleg.patient_titel ? this.beleg.patient_titel + ' ' : '') +
                        (this.beleg.patient_vorname ? this.beleg.patient_vorname + ' ' : '') +
                        (this.beleg.patient_nachname ? this.beleg.patient_nachname + ' ' : '') +
                        (this.beleg.patient_titel_nach_name ? this.beleg.patient_titel_nach_name : ''));
            }

            return '';
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (!visible) return;

            this.resetValidation();
            this.loadImpfstelle();
            this.platzhalterBefuellen();
            this.textErrorMessage = '';
        }

        public resetValidation(): void {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }

        public validateText(): void {
            this.textErrorMessage = '';

            if (this.text === '<p></p>') {
                this.text = '';
            }

            for (const rule of [this.rules.required]) {
                const result = rule(this.text);
                if (result !== true) {
                    this.textErrorMessage = result as string;
                }
            }
        }

        public onClickPrint(isExport: boolean): void {
            this.validateText();

            if (!this.$refs.form.validate() || this.textErrorMessage !== '') {
                return;
            }

            this.printBrief({
                briefe: [this.beleg.beleg_id as number],
                text: this.text ?? '',
                export: isExport,
                name: [this.beleg.patient_vorname, this.beleg.patient_nachname].filter((x) => x).join(' '),
            });
        }

        public onClickClose(): void {
            this.resetValidation();
            this.$emit('close');
        }

        public get textLabelClass(): string {
            return this.textErrorMessage === ''
                ? 'primary--text'
                : 'red--text';
        }
    }
